<template>
  <v-container fluid>
    <v-layout column>
      <v-flex class="mb-3">
        <v-btn color="secondary" dark @click="openNew">הוספת קטגוריה</v-btn>
      </v-flex>

      <v-flex>
        <v-layout row wrap>
          <v-flex xs12 sm6 md4 v-for="item in items" :key="item._id">
            <v-card class="ma-3">
              <v-card-title>
                <div>
                <div class="headline">{{ item.title || item._id }}</div>
                <div class="caption">{{ formatDate(item.date || item.created) }}</div>
                </div>
                <v-spacer></v-spacer>
                <v-btn icon small @click="editItem(item)"><v-icon>edit</v-icon></v-btn>
                <v-btn icon small @click="removeItem(item)"><v-icon color="red">delete</v-icon></v-btn>
              </v-card-title>

              <v-card-text>
            

                <div
                  class="mt-3"
                  v-if="freeText(item.files).length"
                >
                  <div
                    v-for="(f, idx) in freeText(item.files)"
                    :key="'free-'+idx"
                    class="mt-2"
                  >
                    <div class="subtitle-2 font-weight-medium">
                      {{ f.title || '' }}
                    </div>
                    <div v-if="f.url">
                      <a
                        :href="normalizeUrl(f.url)"
                        target="_blank"
                        rel="noopener"
                      >
                        {{ f.url }}
                      </a>
                    </div>
                    <div class="mt-1">
                      {{ f.details }}
                    </div>
                  </div>
                </div>

                <div
                  class="mt-3"
                  v-if="nonFreeText(item.files).length"
                >
                  <strong>מסמכים</strong>
                  <v-list dense>
                    <v-list-tile v-for="(f, idx) in nonFreeText(item.files)" :key="idx">
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <a href="#" @click.prevent="downloadFile(f)">{{ f.name || 'הורדה' }}</a>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>{{ f.details }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </div>
                <div v-else class="grey--text mt-2">אין מסמכים</div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex v-if="!items.length && !loading" class="pa-4">
        <div class="subtitle-1">אין קטגוריות להציג</div>
      </v-flex>

      <v-flex v-if="loading" class="pa-4">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialog" max-width="900">
      <v-card>
        <v-card-title>
          <span class="headline">{{ form._id ? 'עריכת קטגוריה' : 'יצירת קטגוריה' }}</span>
        </v-card-title>
        
        <v-card-text>
          <v-container>
            <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field label="כותרת" v-model="form.title" required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="שם איש קשר" v-model="form.contact.name"></v-text-field>
                </v-flex>
              <v-flex xs12 sm3>
                <v-text-field label="טלפון" v-model="form.contact.phone"></v-text-field>
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field label="אימייל" v-model="form.contact.email"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  label="תאריך"
                  v-model="form.date"
                  type="date"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <div class="my-2 subtitle-1">מסמכים</div>
                <v-btn small @click="addFile">הוספת מסמך</v-btn>
                  <v-btn small class="ml-2" @click="addFreeText">הוספת מלל חופשי</v-btn>
                <v-layout column>
                  <v-flex v-for="(f, idx) in form.files" :key="idx" class="pa-2">
                    <template v-if="f.name === 'מלל חופשי'">
                      <v-text-field label="כותרת" v-model="f.title"></v-text-field>
                      <v-text-field label="קישור (URL)" v-model="f.url"></v-text-field>
                      <v-textarea label="מלל חופשי" v-model="f.details" rows="3"></v-textarea>
                    </template>
                    <template v-else>
                      <v-text-field label="שם" v-model="f.name"></v-text-field>
                      <div class="mt-2 mb-2">
                        <div class="caption mb-1">קובץ</div>
                        <input
                          type="file"
                          @change="handleFileSelected($event, idx)"
                        />
                        <div class="caption grey--text" v-if="f.link">
                          קובץ הועלה
                        </div>
                      </div>
                      <v-textarea label="פרטים" v-model="f.details" rows="2"></v-textarea>
                    </template>
                    <v-btn small color="red" @click="removeFile(idx)">הסר קובץ</v-btn>
                    <v-divider class="my-2"></v-divider>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn flat @click="dialog = false">ביטול</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="save">שמור</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { getApi } from '@/api';
import { format } from 'date-fns';

export default {
  name: 'DashboardInfo',
  data() {
    return {
      items: [],
      loading: false,
      dialog: false,
      form: {
        files: [],
        contact: { name: '', phone: '', email: '' },
        date: ''
      }
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    formatDate(d) {
      return d ? format(new Date(d), 'DD/MM/YYYY') : '';
    },
    freeText(files) {
      if (!Array.isArray(files)) return [];
      return files.filter(
        f =>
          f &&
          f.name === 'מלל חופשי' &&
          (f.details || f.link || f.name || f.title || f.url)
      );
    },
    nonFreeText(files) {
      if (!Array.isArray(files)) return [];
      return files.filter(f => f && f.name !== 'מלל חופשי' && (f.name || f.link || f.details));
    },
    normalizeUrl(url) {
      if (!url) return '';
      const trimmed = url.toString().trim();
      if (!trimmed) return '';
      return /^(https?:)?\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
    },
    handleFileSelected(evt, idx) {
      const file = evt && evt.target && evt.target.files ? evt.target.files[0] : null;
      if (!file) return;
      const reader = new FileReader();
      reader.onload = e => {
        const dataUrl = e.target.result;
        this.$set(this.form.files[idx], 'link', dataUrl);
        if (!this.form.files[idx].name) {
          this.$set(this.form.files[idx], 'name', file.name);
        }
      };
      reader.readAsDataURL(file);
    },
    downloadFile(f) {
      if (!f || !f.link) return;
      const parts = f.link.split(',');
      if (parts.length < 2) return;
      const mimeMatch = parts[0].match(/:(.*?);/);
      const mime = mimeMatch ? mimeMatch[1] : 'application/octet-stream';
      const bstr = atob(parts[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      const blob = new Blob([u8arr], { type: mime });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = f.name || 'download';
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    },
    async fetch() {
      this.loading = true;
      try {
        const api = await getApi();
        const res = await api.get('/general');
          const data = res.data;
          // API may return either an array or an object with `results` (paged response)
          if (Array.isArray(data)) {
            this.items = data;
          } else if (data && Array.isArray(data.results)) {
            this.items = data.results;
          } else {
            this.items = [];
          }
      } catch (err) {
        this.$store.dispatch('SHOW_SNACKBAR', { text: err.message || 'Error', color: 'error' });
      } finally {
        this.loading = false;
      }
    },
    openNew() {
      this.form = {
        title: '',
        date: '',
        files: [{ name: '', link: '', details: '', title: '', url: '' }],
        contact: { name: '', phone: '', email: '' }
      };
      this.dialog = true;
    },
    editItem(item) {
      this.form = JSON.parse(JSON.stringify(item));
      this.form.files = (this.form.files || []).map(file => ({
        ...(file || {}),
        title: (file && file.title) || '',
        url: (file && file.url) || ''
      }));
      if (!this.form.contact) this.form.contact = { name: '', phone: '', email: '' };
      if (!this.form.title) this.form.title = '';
      if (!this.form.date) this.form.date = '';
      this.dialog = true;
    },
    async removeItem(item) {
      if (!confirm('להסיר קטגוריה?')) return;
      try {
        const api = await getApi();
        await api.delete(`/general/${item._id}`);
        this.$store.dispatch('SHOW_SNACKBAR', { text: 'קטגוריה הוסרה', color: 'success' });
        this.fetch();
      } catch (err) {
        this.$store.dispatch('SHOW_SNACKBAR', { text: (err.response && err.response.data && err.response.data.message) || err.message, color: 'error' });
      }
    },
    addFile() {
      this.form.files = this.form.files || [];
      this.form.files.push({ name: '', link: '', details: '' });
    },
    addFreeText() {
      this.form.files = this.form.files || [];
      this.form.files.push({ name: 'מלל חופשי', link: '', details: '', title: '', url: '' });
    },
    removeFile(idx) {
      this.form.files.splice(idx, 1);
    },
    async save() {
      // require title
      if (!this.form.title || !this.form.title.toString().trim()) {
        this.$store.dispatch('SHOW_SNACKBAR', { text: 'יש להזין כותרת', color: 'error' });
        return;
      }

      try {
        const api = await getApi();
        if (this.form._id) {
          await api.patch(`/general/${this.form._id}`, this.form);
          this.$store.dispatch('SHOW_SNACKBAR', { text: 'עודכן בהצלחה', color: 'success' });
        } else {
          await api.post('/general', this.form);
          this.$store.dispatch('SHOW_SNACKBAR', { text: 'נוצר בהצלחה', color: 'success' });
        }
        this.dialog = false;
        await this.fetch();
      } catch (err) {
        this.$store.dispatch('SHOW_SNACKBAR', { text: (err.response && err.response.data && err.response.data.message) || err.message, color: 'error' });
      }
    }
  }
};
</script>

<style scoped>
.headline {
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/DashboardInfo.vue